/** Диапазон байтов from..to (включительно) файла: заголовок Range */
export class FileChunkParams {
  from: number
  to: number

  constructor({ from, to }: { from: number, to: number }) {
    this.from = from
    this.to = to
  }
}
